module.exports = __webpack_public_path__ + "img/manual_inputbox.96002b8e.png";